<div class="sidenav-hold">
  <ul appDropdown class="sidenav" style="font-size: 13px;">
    <li *ngFor="let item of menuItems" appDropdownLink routerLinkActive="open" [ngClass]="item.CssClass">
      <div class="nav-item-sep" *ngIf="item.Type === 'separator'">
        <mat-divider></mat-divider>
        <span class="text-muted">{{item.Name}}</span>
      </div>
      <div *ngIf="!item.Disabled && item.ParentId == null" class="lvl1">
        <a [routerLink]="[item.State]" [queryParams]="item.Params" appDropdownToggle matRipple
          *ngIf="item.Type === 'link'">
          <mat-icon *ngIf="item.Icon" class="sidenav-mat-icon" [matTooltip]="item.Tooltip">{{item.Icon}}</mat-icon>
          <mat-icon *ngIf="item.SvgIcon" [svgIcon]="item.SvgIcon" class="svgIcon"></mat-icon>
          <span class="item-name lvl1">{{item.Name}}</span>
          <span fxFlex></span>
          <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
        </a>
        <!-- DropDown -->
        <a *ngIf="item.childs && item.childs.length && item.childs.length > 0" appDropdownToggle matRipple>
          <mat-icon *ngIf="item.Icon" class="sidenav-mat-icon" matTooltipPosition="above">{{item.Icon}}</mat-icon>
          <mat-icon *ngIf="item.SvgIcon" [svgIcon]="item.SvgIcon" class="svgIcon"></mat-icon>
          <span class="item-name lvl1">{{item.Name}}</span>
          <span fxFlex></span>
          <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}"
            *ngFor="let badge of item.badges">{{ badge.value }}</span>
          <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
        </a>
        <!-- LEVEL 2 -->
        <ul class="submenu lvl2" appDropdown *ngIf="item.childs && item.childs.length && item.childs.length > 0">
          <li *ngFor="let itemLvL2 of sortedList(item.childs)" appDropdownLink routerLinkActive="open"
            [ngClass]="item.CssClass">
            <a [routerLink]="[itemLvL2.State]" [queryParams]="itemLvL2.Params" appDropdownToggle
              *ngIf="!itemLvL2.childs || !itemLvL2.childs.length || itemLvL2.childs.length === 0" matRipple>
              <span class="item-name lvl2">{{itemLvL2.Name}}</span>
              <span fxFlex></span>
            </a>

            <a *ngIf="itemLvL2.childs && itemLvL2.childs.length && itemLvL2.childs.length > 0" appDropdownToggle
              matRipple>
              <span class="item-name lvl2">{{itemLvL2.Name}}</span>
              <span fxFlex></span>
              <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
            </a>

            <!-- LEVEL 3 -->
            <ul class="submenu lvl3" appDropdown
              *ngIf="itemLvL2.childs && itemLvL2.childs.length && itemLvL2.childs.length > 0">
              <li *ngFor="let itemLvL3 of sortedList(itemLvL2.childs)" appDropdownLink routerLinkActive="open"
                [ngClass]="item.CssClass">
                <a [routerLink]="[itemLvL3.State]" [queryParams]="itemLvL3.Params" appDropdownToggle matRipple>
                  <span class="item-name lvl3">{{itemLvL3.Name}}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>